/* ============================================================
   SAMANÁ — Visor de reportes de laboratorio (blog técnico)
   ------------------------------------------------------------
   Los reportes se miran en pantalla, no se descargan. Al tocar una hoja se
   abre a pantalla completa; ahí se puede pasar de un cristal a otro y hacer
   zoom para leer la letra chica.
   Si este archivo no carga, las hojas se siguen viendo en la página (más
   chicas): lo único que se pierde es el visor grande.
   ============================================================ */
(function () {
  'use strict';

  var visor = null;   // se crea una sola vez, la primera vez que hace falta
  var hojas = [];     // [{src, titulo}] del grupo que se está mirando
  var actual = 0;
  var ampliada = false;
  var abridor = null; // botón que abrió el visor, para devolverle el foco

  function crearVisor() {
    var v = document.createElement('div');
    v.className = 'sm-bt-visor';
    v.setAttribute('role', 'dialog');
    v.setAttribute('aria-modal', 'true');
    v.setAttribute('aria-label', 'Reporte de laboratorio');
    v.hidden = true;
    v.innerHTML =
      '<div class="sm-bt-visor__fondo" data-cerrar></div>' +
      '<div class="sm-bt-visor__caja">' +
        '<div class="sm-bt-visor__barra">' +
          '<span class="sm-bt-visor__titulo" data-titulo></span>' +
          '<div class="sm-bt-visor__acciones">' +
            '<button type="button" class="sm-bt-visor__btn" data-zoom aria-pressed="false">Ampliar</button>' +
            '<button type="button" class="sm-bt-visor__btn sm-bt-visor__btn--x" data-cerrar aria-label="Cerrar">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
        '<div class="sm-bt-visor__lienzo" data-lienzo>' +
          '<img class="sm-bt-visor__img" data-img alt="">' +
        '</div>' +
        '<div class="sm-bt-visor__pie">' +
          '<button type="button" class="sm-bt-visor__nav" data-prev aria-label="Reporte anterior">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 5.5L8 12l6.5 6.5"/></svg>' +
          '</button>' +
          '<span class="sm-bt-visor__cuenta" data-cuenta></span>' +
          '<button type="button" class="sm-bt-visor__nav" data-next aria-label="Reporte siguiente">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9.5 5.5L16 12l-6.5 6.5"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(v);

    v.querySelectorAll('[data-cerrar]').forEach(function (b) {
      b.addEventListener('click', cerrar);
    });
    v.querySelector('[data-prev]').addEventListener('click', function () { mover(-1); });
    v.querySelector('[data-next]').addEventListener('click', function () { mover(1); });
    v.querySelector('[data-zoom]').addEventListener('click', alternarZoom);
    v.querySelector('[data-img]').addEventListener('click', alternarZoom);

    return v;
  }

  function pintar() {
    var hoja = hojas[actual];
    if (!hoja) return;
    var img = visor.querySelector('[data-img]');
    img.src = hoja.src;
    img.alt = 'Reporte de laboratorio de los ' + hoja.titulo.toLowerCase();
    visor.querySelector('[data-titulo]').textContent = hoja.titulo;
    visor.querySelector('[data-cuenta]').textContent = (actual + 1) + ' de ' + hojas.length;
    visor.querySelector('[data-lienzo]').scrollTop = 0;
    visor.querySelector('[data-lienzo]').scrollLeft = 0;

    var solaUna = hojas.length < 2;
    visor.querySelector('[data-prev]').hidden = solaUna;
    visor.querySelector('[data-next]').hidden = solaUna;
    visor.querySelector('[data-cuenta]').hidden = solaUna;
  }

  function mover(paso) {
    actual = (actual + paso + hojas.length) % hojas.length;
    zoom(false);
    pintar();
  }

  function zoom(si) {
    ampliada = si;
    visor.classList.toggle('sm-bt-visor--zoom', si);
    var b = visor.querySelector('[data-zoom]');
    b.setAttribute('aria-pressed', si ? 'true' : 'false');
    b.textContent = si ? 'Reducir' : 'Ampliar';
  }

  function alternarZoom() { zoom(!ampliada); }

  function abrir(grupo, indice, boton) {
    if (!visor) visor = crearVisor();
    hojas = grupo;
    actual = indice;
    abridor = boton || null;
    zoom(false);
    pintar();
    visor.hidden = false;
    document.body.classList.add('sm-bt-visor-abierto');
    document.addEventListener('keydown', teclado);
    visor.querySelector('[data-cerrar].sm-bt-visor__btn--x').focus();
  }

  function cerrar() {
    if (!visor) return;
    visor.hidden = true;
    document.body.classList.remove('sm-bt-visor-abierto');
    document.removeEventListener('keydown', teclado);
    if (abridor) { abridor.focus(); abridor = null; }
  }

  function teclado(e) {
    if (e.key === 'Escape') { cerrar(); }
    else if (e.key === 'ArrowRight' && hojas.length > 1) { mover(1); }
    else if (e.key === 'ArrowLeft' && hojas.length > 1) { mover(-1); }
  }

  function init(grupo) {
    if (grupo.dataset.btVisorListo === '1') return;
    grupo.dataset.btVisorListo = '1';

    var botones = Array.prototype.slice.call(grupo.querySelectorAll('[data-bt-doc]'));
    var lista = botones.map(function (b) {
      return { src: b.getAttribute('data-bt-doc'), titulo: b.getAttribute('data-bt-doc-titulo') || 'Reporte' };
    });

    botones.forEach(function (b, i) {
      b.addEventListener('click', function () { abrir(lista, i, b); });
    });
  }

  function arrancar(raiz) {
    var grupos = (raiz || document).querySelectorAll('[data-bt-visor]');
    Array.prototype.forEach.call(grupos, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arrancar(); });
  } else {
    arrancar();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) arrancar(e.target);
  });
})();
